"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var React = __importStar(require("react"));
var braintree_web_drop_in_1 = require("braintree-web-drop-in");
var react_1 = require("react");
var layout_1 = require("@nib/layout");
var styled_components_1 = __importDefault(require("styled-components"));
var theme_1 = require("@nib-components/theme");
var button_1 = require("@nib-components/button");
var alert_1 = __importDefault(require("@nib-components/alert"));
var BraintreeWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  ", "\n"], ["\n  background-color: ", ";\n  ", "\n"])), function (props) {
  return props.instanceExists && theme_1.colorWhite;
}, (0, layout_1.p)(4));
var BraintreeActionsWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), (0, layout_1.pt)(4), (0, layout_1.pb)(4));
// Default option props + any passed in
var getBraintreeOptionsProps = function (props) {
  return __assign({
    locale: 'en_AU'
  }, props);
};
var BraintreeDropIn = function (props) {
  var braintreeClientToken = props.braintreeClientToken,
    onError = props.onError,
    options = props.options,
    braintreeDropInInstanceRef = props.braintreeDropInInstanceRef,
    onCreate = props.onCreate,
    onPreCreate = props.onPreCreate,
    useInternalSubmit = props.useInternalSubmit,
    handleSubmit = props.handleSubmit,
    onPreTeardown = props.onPreTeardown,
    onPostTeardown = props.onPostTeardown;
  var braintreeWrapper = (0, react_1.useRef)(null); //the render of the braintree UI
  var _a = (0, react_1.useState)(undefined),
    instance = _a[0],
    setInstance = _a[1];
  var _b = (0, react_1.useState)(false),
    isSubmitButtonDisabled = _b[0],
    setIsSubmitButtonDisabled = _b[1];
  var _c = (0, react_1.useState)(),
    createError = _c[0],
    setCreateError = _c[1];
  // Initialise braintree if braintree token changes
  var initPaymentInstance = (0, react_1.useCallback)(function () {
    return __awaiter(void 0, void 0, void 0, function () {
      var error_1;
      var _a;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            if (!braintreeClientToken) return [2 /*return*/];
            _b.label = 1;
          case 1:
            _b.trys.push([1, 3,, 4]);
            onPreCreate && onPreCreate();
            return [4 /*yield*/, (0, braintree_web_drop_in_1.create)(__assign({
              authorization: braintreeClientToken,
              container: (_a = braintreeWrapper.current) !== null && _a !== void 0 ? _a : ''
            }, getBraintreeOptionsProps(options))).then(function (dropinInstance) {
              // Perform all logic on the returned drop in Instance
              onCreate && onCreate(dropinInstance);
              // handlers
              if (props.onNoPaymentMethodRequestable) {
                dropinInstance.on('noPaymentMethodRequestable', props.onNoPaymentMethodRequestable);
              }
              if (props.onPaymentMethodRequestable) {
                dropinInstance.on('paymentMethodRequestable', props.onPaymentMethodRequestable);
              }
              if (props.onPaymentOptionSelected) {
                dropinInstance.on('paymentOptionSelected', props.onPaymentOptionSelected);
              }
              if (dropinInstance.isPaymentMethodRequestable() && useInternalSubmit) {
                setIsSubmitButtonDisabled(true);
              }
              setInstance(dropinInstance);
            }).catch(function (createError) {
              handleError(setCreateError, createError);
            })];
          case 2:
            _b.sent();
            return [3 /*break*/, 4];
          case 3:
            error_1 = _b.sent();
            handleError(setCreateError, createError);
            return [3 /*break*/, 4];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  }, [braintreeClientToken]);
  // Set the appropriate internal error and call the onError prop if it exists
  var handleError = function (errorFunc, error) {
    errorFunc(error);
    onError && onError(error);
  };
  var handleBraintreeSubmit = function (event) {
    if (instance && useInternalSubmit && !isSubmitButtonDisabled) {
      setIsSubmitButtonDisabled(true);
      instance.requestPaymentMethod().then(function (payload) {
        setIsSubmitButtonDisabled(false);
        handleSubmit && handleSubmit(payload, event);
      }).catch(function (error) {
        onError && onError(error);
        setIsSubmitButtonDisabled(false);
      });
    }
  };
  var handleBraintreeTeardown = function () {
    onPreTeardown && onPreTeardown();
    return new Promise(function (res, rej) {
      if (!instance) return;
      instance.teardown().then(function () {
        res('');
        onPostTeardown && onPostTeardown();
      }).catch(function (error) {
        onPostTeardown && onPostTeardown(error);
        rej(error);
      });
    });
  };
  // initialise component - only if init callback needs to be called again (token change)
  (0, react_1.useEffect)(function () {
    initPaymentInstance();
  }, [initPaymentInstance]);
  // Set reference when our local reference changes (after create or teardown)
  (0, react_1.useEffect)(function () {
    if (braintreeDropInInstanceRef) {
      braintreeDropInInstanceRef.current = instance;
    }
    return function () {
      if (!instance) return;
      handleBraintreeTeardown().catch(function (error) {
        onError && onError(error);
      });
    };
    // set useref from parent to local instance.
    // Call unmount equivalent if the reference changes or component is unmounted
  }, [instance, braintreeDropInInstanceRef]);
  return React.createElement(React.Fragment, null, createError && props.renderErrorNotification ? props.renderErrorNotification({
    errorTitle: "Something's gone wrong.",
    errorMessage: 'You can try refreshing the page, or call us on 13 16 42 if you continue to see this error.'
  }) : React.createElement(BraintreeWrapper, {
    instanceExists: instance
  }, React.createElement("div", {
    ref: braintreeWrapper
  }), instance && useInternalSubmit && React.createElement(BraintreeActionsWrapper, null, props.renderSubmitButton && props.renderSubmitButton({
    onClick: handleBraintreeSubmit,
    isDisabled: isSubmitButtonDisabled,
    buttonText: 'Purchase',
    buttonType: 'button'
  }))));
};
/* For if we want to use internal submit, provide a default render button */
var renderSubmitButton = function (_a) {
  var onClick = _a.onClick,
    isDisabled = _a.isDisabled,
    buttonText = _a.buttonText,
    buttonType = _a.buttonType;
  return (
    // eslint-disable-next-line
    // @ts-ignore
    React.createElement(button_1.PrimaryButton, {
      type: buttonType,
      onClick: onClick,
      isDisabled: isDisabled
    }, buttonText)
  );
};
var renderErrorNotification = function (_a) {
  var errorTitle = _a.errorTitle,
    errorMessage = _a.errorMessage;
  return React.createElement(layout_1.Margin, {
    bottom: 4
  }, React.createElement(alert_1.default, {
    title: errorTitle,
    type: "error"
  }, errorMessage));
};
BraintreeDropIn.defaultProps = {
  renderSubmitButton: renderSubmitButton,
  renderErrorNotification: renderErrorNotification
};
exports.default = BraintreeDropIn;
var templateObject_1, templateObject_2;